export default __webpack_public_path__ + "static/media/13_SchererGruppe-DTM-Documentary-EschweilerPhotography_21A3646.53df88b2.jpg";